var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _rect4, _ellipse, _circle, _ellipse2, _ellipse3, _ellipse4, _circle2, _ellipse5, _ellipse6, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClacleta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1155,
    height: 1132,
    viewBox: "0 0 1155 1132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 447,
    width: 1100,
    height: 685,
    rx: 48,
    fill: "#EAEDED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 267.844,
    width: 1049.7,
    height: 139.62,
    transform: "rotate(-12.8692 89 267.844)",
    fill: "#D0D3D4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 378,
    width: 1100,
    height: 138,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1015 379H1155L1074 517H941L1015 379Z",
    fill: "#282323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M811 379H951L870 517H737L811 379Z",
    fill: "#282323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M597 379H737L656 517H523L597 379Z",
    fill: "#282323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M383 379H523L442 517H309L383 379Z",
    fill: "#282323"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M377 345.5L271.096 222.379L406 194.5L523 312L377 345.5Z",
    fill: "#282323"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M590 296.5L482 177L614.481 146.852L730 266L590 296.5Z",
    fill: "#282323"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M793.879 250.214L690.63 128.797L823.23 98.4568L933 217.5L793.879 250.214Z",
    fill: "#282323"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.5 202.5L894.929 83.4461L1028.24 53.8631L1143 170L1008.5 202.5Z",
    fill: "#282323"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_52_60)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 107,
    cy: 369,
    rx: 103,
    ry: 101,
    fill: "#C4C4C4"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 565,
    width: 972,
    height: 481,
    fill: "#2A2727"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 416.5,
    cy: 742.5,
    rx: 156.5,
    ry: 153.5,
    fill: "#C4C4C4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 416.5,
    cy: 742.5,
    r: 91.5,
    fill: "#282323"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 457.5,
    cy: 716.5,
    rx: 23.5,
    ry: 25.5,
    fill: "#F3E1E1"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.5,
    cy: 741.5,
    rx: 42.5,
    ry: 47.5,
    fill: "#F3E1E1"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 813.5,
    cy: 742.5,
    rx: 156.5,
    ry: 153.5,
    fill: "#C4C4C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 813.5,
    cy: 742.5,
    r: 91.5,
    fill: "#282323"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 785.5,
    cy: 719.5,
    rx: 23.5,
    ry: 25.5,
    fill: "#F3E1E1"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 829.885,
    cy: 746.666,
    rx: 42.5,
    ry: 47.5,
    transform: "rotate(-12.6721 829.885 746.666)",
    fill: "#F3E1E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M951 950.89C951 975.251 931.077 995 906.5 995C881.923 995 862 975.251 862 950.89C862 926.529 881.923 815 906.5 815C931.077 815 951 926.529 951 950.89Z",
    fill: "#498DCD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_52_60",
    x: 0,
    y: 268,
    width: 214,
    height: 212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_52_60"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_52_60",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClacleta);
export default __webpack_public_path__ + "static/media/clacleta.b5d5020751eb839fe5eed5b433085b7f.svg";
export { ForwardRef as ReactComponent };